/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Force_DisconnectInputs */

const en_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force Disconnect`)
};

const es_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forzar desconexión`)
};

const fr_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forcer la déconnexion`)
};

const de_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trennung erzwingen`)
};

const ja_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制切断`)
};

const zh_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制断开连接`)
};

const ar_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرض قطع الاتصال`)
};

const id_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paksa Putuskan Koneksi`)
};

const it_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza Disconnessione`)
};

const ru_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительное отключение`)
};

const pt_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçar Desconexão`)
};

const ko_force_disconnect = /** @type {(inputs: Force_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`강제 연결 해제`)
};

/**
* | output |
* | --- |
* | "Force Disconnect" |
*
* @param {Force_DisconnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const force_disconnect = /** @type {((inputs?: Force_DisconnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Force_DisconnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_force_disconnect(inputs)
	if (locale === "es") return es_force_disconnect(inputs)
	if (locale === "fr") return fr_force_disconnect(inputs)
	if (locale === "de") return de_force_disconnect(inputs)
	if (locale === "ja") return ja_force_disconnect(inputs)
	if (locale === "zh") return zh_force_disconnect(inputs)
	if (locale === "ar") return ar_force_disconnect(inputs)
	if (locale === "id") return id_force_disconnect(inputs)
	if (locale === "it") return it_force_disconnect(inputs)
	if (locale === "ru") return ru_force_disconnect(inputs)
	if (locale === "pt") return pt_force_disconnect(inputs)
	return ko_force_disconnect(inputs)
});